<template>
    <b-form-group
        :label="label"
        :label-for="id"
        :class="{
            'label-sm': labelSize === 'sm',
            'label-md': labelSize === 'md',
            'label-lg': labelSize === 'lg',
        }"
    >
        <b-input-group class="ms-price-input">
            <b-input-group-prepend
                v-if="enableIcon"
                data-toggle
            >
                <b-input-group-text class="input-group-text-coherent ">
                    <a class="input-button">
                        <i :class="icon"/>
                    </a>
                </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
                :id="id"
                v-model="inputValue"
                class="form-control"
                :class="inputClass"
                :placeholder="placeholder"
                :name="name"
                :disabled="disabled"
                @keypress="isNumber($event)"
                @focus="onFocus"
                @blur="onBlur"
                @input="onInput"
                :autocomplete="autocomplete"
            />
        </b-input-group>
        <input-error
            :errors="errors"
            :field="name"
        />
    </b-form-group>
</template>
<script>
import './PriceInput.scss';
import {formatValue} from "./../../../helpers/numberHelpers";
import {generateRandomString} from "./../../../helpers/stringHelpers";
import InputError from "../../InputError/InputError.vue";

export default {
    name: 'PriceInput',
    components: {InputError},
    props: {
        value: {
            type: [
                String,
                Number
            ],
        },
        name: {
            type: String,
            required: false,
            default: () => {
                return 'price';
            }
        },
        label: {
            type: String,
            required: false,
            default: () => {
                return '';
            }
        },
        enableIcon: {
            type: Boolean,
            required: false,
            default: () => {
                return true;
            }
        },
        icon: {
            type: String,
            required: false,
            default: () => {
                return 'far fa-dollar-sign';
            }
        },
        id: {
            type: String,
            required: false,
            default: () => {
                return generateRandomString(10);
            }
        },
        placeholder: {
            type: String,
            required: false,
            default: () => {
                return '';
            }
        },
        inputClass: {
            type: [String, Object],
            required: false,
            default: () => {
                return '';
            }
        },
        disabled: {
            type: Boolean,
            required: false,
            default: () => {
                return false;
            }
        },
        errors: {
            type: Object,
            required: false,
            default: () => ({})
        },
        labelSize: {
            type: String,
            required: false,
            default: 'sm',
            validator: (value) => {
                return [
                    'sm',
                    'md',
                    'lg'
                ].indexOf(value) > -1;
            }
        },
        autocomplete: {
            type: String,
            required: false,
            default: 'off'
        },
    },
    data: () => ({
        inputValue: '',
        formattedValue: '',
    }),
    computed: {
    },
    methods: {
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            const charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        onFocus() {
            this.inputValue = this.value;
        },
        onBlur() {
            if (
                this.inputValue === '' ||
                Number.isNaN(parseFloat(this.inputValue)) ||
                Number.isNaN(this.inputValue)
            ) {
                this.inputValue = 0;
            }
            this.inputValue = formatValue(this.inputValue, 'currency');
        },
        onInput(value) {
            this.$emit('input', value);
        }
    },
    beforeMount() {
        if (
            this.value &&
            !Number.isNaN(parseFloat(this.value))
        ) {
            this.inputValue = formatValue(this.value, 'currency');
        }
    }
}
</script>
